import { importScheduleDialogViewState } from "../";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setTryImportingAgainButton", function setTryImportingAgainButton(showButton: boolean) {
    importScheduleDialogViewState().hideTryImportAgainButton = showButton;
});